export default {
  path: '/exam',
  name: 'exam',
  component: () => import('@/views/exam/Exam.vue'),
};
